const CompanyFormatter = ({ value }) => {
    return value ? value.name : '';
};

export default CompanyFormatter;
